'use client';

import {FiDownload, FiFileText} from 'react-icons/fi';
import {track} from '@/lib/analytics';

type Download = {_key: string; title?: string | null; file?: string | null};

const DownloadList = ({items, productTitle}: {items: Download[]; productTitle?: string | null}) => (
  <ul className='grid gap-4 sm:grid-cols-2'>
    {items.map(({_key, title, file}) =>
      file ? (
        <li key={_key}>
          <a
            href={file}
            target='_blank'
            rel='noopener'
            onClick={() => track('datasheet_download', {file_name: title ?? file, product: productTitle ?? ''})}
            className='group flex items-center gap-4 rounded-2xl bg-white p-5 text-zinc-900 no-underline ring-1 ring-zinc-200 transition hover:text-zinc-900 hover:shadow-lg hover:ring-brand-300'>
            <span className='flex size-12 shrink-0 items-center justify-center rounded-xl bg-brand-50 text-brand-700'>
              <FiFileText className='size-6' aria-hidden />
            </span>
            <span className='flex-1 font-medium'>{title}</span>
            <FiDownload className='size-5 text-zinc-400 transition group-hover:text-brand-700' aria-hidden />
          </a>
        </li>
      ) : null
    )}
  </ul>
);

export default DownloadList;
